<nav>

    <div class="main">
    
        <div class="flex_row_home">
    
            <img src="assets/images/logo-nis.png">
    
            <div class="menu">

                <ul class="nav-links login_nav" >
                    <li><a href="https://immigration.gov.ng/">Home</a></li>
                    <!-- <li><a href="javascript:void(0);" (click)="openApplicationSearchPage()">Payment Status</a></li> -->
                    <li><a href="javascript:void(0);" class="custom_btn" (click)="doLogin()">Sign In</a></li>
                </ul>
    
            </div>
    
        </div>

    </div>

</nav>
